import axios from 'axios';
import get from 'lodash/get';

export const defaultState = {
  strategies: [],
  ddAccounts: [],
  ddAccountsPagination: {
    page: 1,
    rowsPerPage: 25,
    sortBy: 'timestamp',
    descending: true,
  },
  strategyHistory: [],
  strategyLatest: {},
};

export const mutations = {
  SET_DD_ACCOUNTS_DATA(strategiesState, data) {
    strategiesState.ddAccounts = data;
  },
  SET_DD_ACCOUNTS_PAGINATION(strategiesState, data) {
    strategiesState.ddAccountsPagination = Object.assign(
      strategiesState.ddAccountsPagination,
      data,
    );
  },
  SET_STRATEGIES_DATA(strategiesState, data) {
    strategiesState.strategies = data;
  },
  SET_STRATEGIES_HISTORY_DATA(strategiesState, data) {
    strategiesState.strategyHistory = data;
  },
  SET_STRATEGIES_LATEST_DATA(strategiesState, data) {
    strategiesState.strategyLatest = data;
  },
};

export const getters = {
  getStrategies: strategiesState => strategiesState.strategies,
  getStrategyHistory: strategiesState => strategiesState.strategyHistory,
  getStrategyLatest: strategiesState => strategiesState.strategyLatest,
};

export const actions = {
  fetchDigitalDepotAccounts({ commit }, params) {
    return axios
      .get(
        `${window.BASE_API.STRATEGIES}/strategy-admin/?key=${
          params ? params.key : ''
        }&value=${params ? params.value : ''}`,
      )
      .then(({ data }) => {
        commit('SET_STRATEGIES_DATA', data.data);

        return data.data;
      })
      .catch((error) => {
        commit('SET_STRATEGIES_DATA', []);

        return Promise.reject(error);
      });
  },
  setDdAccountsPagination({ commit }, query) {
    commit('SET_DD_ACCOUNTS_PAGINATION', {
      rowsPerPage: query.rowsPerPage,
      page: query.page,
    });
  },
  async fetchDdAccounts({ commit }, params) {
    const field = 'detail.id';
    const query = {
      from: (params.page ? params.page - 1 : 0) * params.rowsPerPage,
      size: params.rowsPerPage,
      query: {
        ...(params.search
          ? {
            multi_match: { query: params.search, operator: 'and' },
          }
          : {
            match_all: {},
          }),
      },
      collapse: {
        field,
        inner_hits: {
          name: 'most_recent',
          size: 10000,
          sort: [
            {
              'detail.timestamp': 'desc',
            },
          ],
        },
      },
      sort: [
        {
          'detail.timestamp': {
            order: 'desc',
          },
        },
      ],
    };
    const totalQuery = {
      query: {
        ...(params.search
          ? {
            multi_match: { query: params.search, operator: 'and' },
          }
          : {
            match_all: {},
          }),
      },
      aggs: {
        type_count: {
          cardinality: {
            field,
          },
        },
      },
    };

    try {
      commit('SET_DD_ACCOUNTS_DATA', []);
      const response = await axios.post(
        `${window.BASE_API.CENTRAL_EVENTS_STORE}/opensearch/dd_accounts`,
        query,
      );
      const responseTotal = await axios.post(
        `${window.BASE_API.CENTRAL_EVENTS_STORE}/opensearch/dd_accounts`,
        totalQuery,
      );
      const accounts = response.data.hits.hits.map(
        hit => hit._source && {
          ...get(hit, '_source.detail'),
          history: (
            get(hit, 'inner_hits.most_recent.hits.hits') || []
          ).map(innerHit => get(innerHit, '_source.detail')),
        },
      );
      commit('SET_DD_ACCOUNTS_DATA', accounts);
      commit('SET_DD_ACCOUNTS_PAGINATION', {
        total: get(responseTotal, 'data.aggregations.type_count.value'),
        rowsPerPage: params.rowsPerPage,
        page: params.page,
      });

      return accounts;
    } catch (error) {
      console.error(error);
      commit('SET_DD_ACCOUNTS_DATA', []);

      return error;
    }
  },
  fetchStrategyHistory({ commit }, strategyId) {
    return axios
      .get(`${window.BASE_API.STRATEGIES}/strategy-admin/${strategyId}/history`)
      .then(({ data }) => {
        commit('SET_STRATEGIES_HISTORY_DATA', data);

        return data.data;
      })
      .catch((error) => {
        commit('SET_STRATEGIES_HISTORY_DATA', []);

        return Promise.reject(error);
      });
  },
  fetchStrategyLatest({ commit }, strategyId) {
    return axios
      .get(`${window.BASE_API.STRATEGIES}/strategy-admin/${strategyId}/latest`)
      .then(({ data }) => {
        commit('SET_STRATEGIES_LATEST_DATA', data);

        return data.data;
      })
      .catch((error) => {
        commit('SET_STRATEGIES_LATEST_DATA', []);

        return Promise.reject(error);
      });
  },
  // eslint-disable-next-line no-unused-vars
  fetchStrategyById({ commit }, strategyId) {
    return axios
      .get(`${window.BASE_API.STRATEGIES}/strategy-admin/${strategyId}`)
      .then(({ data }) => data)
      .catch(error => Promise.reject(error));
  },
  // eslint-disable-next-line no-unused-vars
  storeStrategy({ dispatch }, payload) {
    return axios
      .post(`${window.BASE_API.STRATEGIES}/strategy-admin/store`, payload)
      .then(data => data)
      .catch((err) => {
        const error =
          err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  // eslint-disable-next-line no-unused-vars
  strategyPushLatestState({ dispatch }, payload) {
    return axios
      .post(
        `${window.BASE_API.STRATEGIES}/strategy-admin/pushLatestState`,
        payload,
      )
      .then(data => data)
      .catch((err) => {
        const error =
          err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
};

const strategies = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default strategies;



// WEBPACK FOOTER //
// ./src/store/digitalDepots/strategies.js